var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SChipBasic,{attrs:{"text":_vm.name,"icon":_setup.icon,"color":_vm.color,"size":_vm.size,"should-truncate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }